import { useProposal } from '../../../application/product/proposal/ProposalProvider'
import { getCurrentQuote, PolicyChangeType } from '../../../domain'
import { useApiErrorHandlingAsyncCallback } from '../../auth'
import { ExcessData } from '../policy'

export const useProposalExcessAdjustment = (onComplete?: () => void) => {
  const { proposal, commit } = useProposal()

  const quote = getCurrentQuote(proposal)

  return useApiErrorHandlingAsyncCallback(async (data: ExcessData) => {
    const existingVoluntaryExcess = quote.excessLines.find(
      (it) => it.voluntaryExcessCode === data.excessCode,
    )?.voluntaryExcess

    await commit({
      applyRating: true,
      changes:
        data.excess === existingVoluntaryExcess
          ? []
          : [
              {
                changeType: PolicyChangeType.SELECT_VOLUNTARY_EXCESS,
                ...data,
              },
            ],
    })

    onComplete?.()
  })
}
